import { render, staticRenderFns } from "./MainCategoryPage.vue?vue&type=template&id=437e79aa"
import script from "./MainCategoryPage.vue?vue&type=script&lang=js"
export * from "./MainCategoryPage.vue?vue&type=script&lang=js"
import style0 from "./MainCategoryPage.vue?vue&type=style&index=0&id=437e79aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports